import { Injectable } from "@angular/core";
import { ApiEsService } from "./api-es.service";

@Injectable({
    providedIn: "root",
})
export class RequestsOperationsESService {

    constructor(private apiService: ApiEsService) {}

    public setNewRequestES(args) {
        return this.apiService.callServicePost("solar.services.support.create", args);
    }

    public getList() {
        return this.apiService.callServicePostToCollection("solar.services.support.getCases", {});
    }

}
